export interface DashboardTourStep {
  id: string;
  targetId: string;
  titleKey: string;
  descriptionKey: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const DASHBOARD_TOUR_STEPS: DashboardTourStep[] = [
  {
    id: 'memory',
    targetId: 'side-nav-memory-item',
    titleKey: 'dashboard_tour_memory_title',
    descriptionKey: 'dashboard_tour_memory_description',
    placement: 'right',
  },
  {
    id: 'app-bar',
    targetId: 'app-bar-header',
    titleKey: 'dashboard_tour_app_bar_title',
    descriptionKey: 'dashboard_tour_app_bar_description',
    placement: 'bottom',
  },
  {
    id: 'side-nav',
    targetId: 'side-nav-tour-anchor',
    titleKey: 'dashboard_tour_side_nav_title',
    descriptionKey: 'dashboard_tour_side_nav_description',
    placement: 'right',
  },
  {
    id: 'chat',
    targetId: 'open-google-chat-app-bar',
    titleKey: 'dashboard_tour_chat_title',
    descriptionKey: 'dashboard_tour_chat_description',
    placement: 'bottom',
  },
  {
    id: 'org',
    targetId: 'org-selector-tour-anchor',
    titleKey: 'dashboard_tour_org_title',
    descriptionKey: 'dashboard_tour_org_description',
    placement: 'bottom',
  },
  {
    id: 'profile',
    targetId: 'navbar_user_profile_btn',
    titleKey: 'dashboard_tour_profile_title',
    descriptionKey: 'dashboard_tour_profile_description',
    placement: 'bottom',
  },
];
